import { gql } from "@apollo/client";

const GET_APPLICATION_HIGHLIGHTS = gql`
  query GetApplicationHighlights($filters: TagFilter) {
    applicationHighlights(filters: $filters) {
      nodes {
        name
        id
      }
    }
  }
`;

export { GET_APPLICATION_HIGHLIGHTS };
